import { api } from '../../base';
import { IServerAssignment } from '../../common';

export const fetchDashboardStats = () => {
    return api.get({ url: `dashboard/statistics/` });
};

export const fetchDashboardNotifications = () => {
    return api.get({ url: `notifications/` });
};

export const updateNotificationsRead = (id: string) => {
    return api.patch({
        url: `notifications/${id}/is_read/`,
        data: { is_read: true },
    });
};

export const updateNotificationsReadAll = () => {
    return api.patch({ url: `notifications/read_all/` });
};

export const fetchDashboardAssignments = () => {
    return api.get({ url: `assignments/` });
};

export const updateDashboardAssignment = (
    id: string,
    payload: IServerAssignment
) => {
    return api.patch({ url: `assignments/${id}/`, data: payload });
};

export const createDashboardAssignment = (payload: IServerAssignment) => {
    return api.post({ url: `assignments/`, data: payload });
};

export const deleteDashboardAssignment = (id: string) => {
    return api.delete({ url: `assignments/${id}/` });
};

export const fetchDashboardTrackableStatistics = () => {
    return api.get({ url: `dashboard/trackablesourcestatistics/` });
};
